import classnames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import certificateValidity from '../../state/calculations/certificateValidity'

import styles from './CertificateValidity.module.scss'

export default React.memo(function Validity({ until }: { until: Date | null | undefined }) {
  const { t } = useTranslation()

  const { validity, daysLeft } = certificateValidity(until)

  if (validity === 'invalid') {
    return <span className={classnames(styles.CertificateValidity, styles.invalid)}>{t('certificate.invalid')}</span>
  }

  if (validity === 'barelyValid') {
    return (
      <span className={classnames(styles.CertificateValidity, styles.barelyValid)}>
        {t('certificate.<count> days left', { count: daysLeft })}
      </span>
    )
  }

  return <span className={classnames(styles.CertificateValidity, styles.valid)}>{t('certificate.valid')}</span>
})
